import jQuery from "jquery";
import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

let $ = jQuery.noConflict();
export class ZIDXAccountDataFeedStatus implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountDataFeedStatusContainer";
    }
    stopReload=false;
    render(){
        // console.log("data feed status");
        let self=this;
        $(".zidxAccountDataFeedStatusContainer.zidxPageActive.a", this.zidx.peakidxShadowRoot).on("click", function(){
            self.stopReload=true;
        });
        setTimeout(function(){
            self.updateData();
        }, 3000);
    }
    updateData() {
        let self=this;
        if(self.stopReload){
            return;
        }
        if ($(".zidxAccountDataFeedStatusContainer.zidxPageActive", this.zidx.peakidxShadowRoot).length > 0) {
            let obj = {
                id: "ajaxDataFeedStatus",
                method: "get",
                postObj: {},
                ignoreOldRequests: false,
                callback: function (r: string) {
                    if(self.stopReload){
                        return;
                    }
                    let js:any;
                    try{
                        js = JSON.parse(r);
                    }catch(e){
                        js = {success:false};
                    }
                    if (js.success) {
                        $(".feedStatusDynamicDiv", $(".zidxAccountDataFeedStatusContainer.zidxPageActive", self.zidx.peakidxShadowRoot)).html(js.data);
                    } else {
                        $(".feedStatusDynamicDiv", $(".zidxAccountDataFeedStatusContainer.zidxPageActive", self.zidx.peakidxShadowRoot)).html("Failed to retrieve status");
                    }
                    setTimeout(function(){
                        if(self.stopReload){
                            return;
                        }
                        self.updateData();
                    }, 3000);
                },
                errorCallback: function (r: string) {
                    if(self.stopReload){
                        return;
                    }
                    $(".feedStatusDynamicDiv", $(".zidxAccountDataFeedStatusContainer.zidxPageActive", self.zidx.peakidxShadowRoot)).html("Failed to retrieve status, there may be a network problem.");
                    setTimeout(function(){
                        if(self.stopReload){
                            return;
                        }
                        self.updateData();
                    }, 3000);
                },
                url: self.zidx.zidxBase.urlAppend(window.location.href,"liveUpdate=1")
            };
            this.zidx.ajaxRequest(obj);
        }
    }
}